import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const encoder = {
  namespaced: true,
  state: {
    setting: {},
    dirtyTable: {},
    encoders: [],
  },
  getters,
  actions,
  mutations,
};

export default encoder;
